<template>
  <div>
    <!-- 位置名称 动态 -->
    <bread-crumb></bread-crumb>
    <el-form ref="pgc-search-form" :model="form" label-width="100px" class="pgcQa-search">
      <el-form-item label="操作类型">
        <el-select v-model="form.operationType" placeholder="请选择">
          <el-option
            key="99"
            label="请选择"
            value=""
          ></el-option>
          <el-option
            key="1"
            label="导入进度查询"
            value="1"
          ></el-option>
          <el-option
            key="2"
            label="导出进度查询"
            value="2"
          ></el-option>
          <el-option
            key="3"
            label="其他操作查询"
            value="3"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSumit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="pgcQa--tabel">
      <div class="base-table">
        <div class="base-table-table">
          <el-table :data="pgcQaList" :border="true" stripe>
            <el-table-column
              prop="recordName"
              label="任务名称"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="操作时间"
            >
            </el-table-column>
            <el-table-column
              prop="createUser"
              label="操作人"
              >
            </el-table-column>
            <el-table-column
              label="状态"
            >
              <template slot-scope="scope">
                <span>{{ statuss(scope.row.status) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <a style="color: blue" v-if="scope.row.url" :href="scope.row.url" >下载执行结果</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    />
  </div>
</template>

<script>
import breadCrumb from "@/components/wiki/breadCrumb";
import pagination from "@/components/wiki/pagination";

import { pgcQueryRecordsByParam } from "@/api/man";

export default {
  name: "pgcRecord",
  data() {
    return {
      form: {
        operationType:''
      },
      // 列表数据
      pgcQaList:[],
      // 分页
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
    }
  },
  components: {
    breadCrumb,
    pagination
  },
  created() {
    this.getRecords();
  },
  methods: {
    statuss(val) {
      const obj = {
        1: '执行中',
        2: '已完成',
        3: '执行失败'
      }
      return obj[val] || val;
    },
    // 获取数据
    getRecords(val) {
      if (val) {
        this.paginationDataProduct.currentPage = val;
      }

      pgcQueryRecordsByParam({
        limit: this.paginationDataProduct.pageSize,
        page: this.paginationDataProduct.currentPage,
        ...this.form
      }).then(res => {
        console.log("🚀 ~ file: pgcRecord.vue:149 ~ getRecords ~ res:", res)
        this.pgcQaList = res.list;
        this.paginationDataProduct.total = res.total;
        this.paginationDataProduct.currentPage = res.pageNum;
        this.paginationDataProduct.pageSize = res.pageSize;
      })
    },
    // 搜索
    onSumit() {
      console.log('form', this.form)
      this.paginationDataProduct.currentPage = 1;
      this.getRecords();
    },
    // 切换页码
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      console.log('paginationChangeProduct', this.paginationDataProduct)
      this.getRecords()
    }
  }
};
</script>

<style lang="scss" scoped>
.pgcQaDetail-info{
  padding: 20px 0px 20px 33px;
  background: #fff;
  margin-bottom: 10px;
  font-size: 14px;
  color: rgb(81, 101, 121);
}
.pgcQa-search{
  display: flex;
  padding: 20px 0px 20px 33px ;
  margin-bottom: 10px;
  align-items: center;
  background: #fff;
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
